// extracted by mini-css-extract-plugin
module.exports = {"subjectCard":"subjectInfoCard_subjectCard__jMqlf","customerNumber":"subjectInfoCard_customerNumber__1CyVu"};